import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { I18n, Translate } from 'react-redux-i18n'

Modal.setAppElement('#root')

const customStyles = {
  content: {
    top: '40%',
    left: '50%',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '320px',
    maxWidth: '680px',
    padding: '20px 24px'
  }
}

const STORAGE_KEY = 'resale-pricing-info-modal-dismissed-v2'

const ResalePricingInfoModal = () => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (window.localStorage.getItem(STORAGE_KEY) !== '1') {
      setOpen(true)
    }
  }, [])

  const closeModal = () => {
    window.localStorage.setItem(STORAGE_KEY, '1')
    setOpen(false)
  }

  return (
    <Modal
      isOpen={open}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Resale Pricing Info Modal"
    >
      <h2>
        <Translate value="tickets.service_fee_popup_title" dangerousHTML />
      </h2>
      <p>
        <Translate value="tickets.service_fee_popup_body" dangerousHTML />
      </p>
      <div className="text-right">
        <button onClick={closeModal}>
          {I18n.t('general.close')}
        </button>
      </div>
    </Modal>
  )
}

export default ResalePricingInfoModal
